export const anggaranPemasukanFilter = (
  dropdownTahunAnggaranPemasukan,
  dropdownUnitUsaha
) => {
  return [
    {
      id: "tahun",
      label: "Tahun",
      options: dropdownTahunAnggaranPemasukan,
    },
    {
      id: "unit_usaha",
      label: "Unit Usaha",
      options: dropdownUnitUsaha,
    },
  ];
};
